import { render, staticRenderFns } from "./AccountVerificationFailed.vue?vue&type=template&id=73b390d5&"
import script from "./AccountVerificationFailed.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports